import { ReactElement } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

const Loading = ({ isLoading, isInner }: Props): ReactElement | null => {
  if (!isLoading) return null;
  return (
    <>
      <div
        style={{
          position: isInner ? "absolute" : "fixed",
          inset: 0,
          backgroundColor: "rgba(255,255,255,0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999
        }}
      >
        <ClipLoader
          size={50}
          color="rgb(250, 178, 50)"
          speedMultiplier={1.5}
        />
      </div>
    </>
  );
};

type Props = {
  isLoading: boolean;
  isInner?: boolean;
};

export default Loading;
